import {
  getBillingProviderCopy,
  resolveLegalIdentityDisplay,
  type BillingProviderCopy,
  type LegalIdentityDisplay,
} from '@maintenance-tracker/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './utils';

export type PublicConfig = {
  /** Optional external origin (MARKETING_ORIGIN). Blank = standalone in-app landing at `/`. */
  marketingOrigin?: string;
  turnstileSiteKey: string | null;
  billingProvider: 'paddle' | 'dodo' | 'stripe';
  billingCopy: BillingProviderCopy;
  integrationsLive: boolean;
  legalIdentityDisplay: LegalIdentityDisplay;
  /** True only when GOOGLE_CLIENT_ID and GOOGLE_CLIENT_SECRET are set (D15). */
  googleSignIn?: boolean;
};

export function usePublicConfig() {
  return useQuery({
    queryKey: ['public-config'],
    queryFn: () => api<PublicConfig>('/api/v1/public-config'),
    staleTime: 1000 * 60 * 60,
  });
}

export function useBillingCopy(): BillingProviderCopy {
  const { data } = usePublicConfig();
  return data?.billingCopy ?? getBillingProviderCopy('paddle');
}

export function useLegalIdentityDisplay(): LegalIdentityDisplay {
  const { data } = usePublicConfig();
  return data?.legalIdentityDisplay ?? resolveLegalIdentityDisplay();
}
